import { render } from "./App.vue?vue&type=template&id=12216dfb"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./assets/tailwind.postcss?vue&type=style&index=0&lang=postcss"
import "./assets/main.css?vue&type=style&index=1&lang=css"
script.render = render

export default script